import React, { FC } from 'react';
import { Grid } from '@material-ui/core';

import { Partner } from '@constants/paymentLink';

import openpayLogo from '@assets/images/partners/openpay.png';
import redpayLogo from '@assets/images/partners/redpay.png';
import blumonLogo from '@assets/images/partners/blumon.png';
import stpLogo from '@assets/images/partners/stp.png';
import belvoLogo from '@assets/images/partners/belvo.png';
import kushkiLogo from '@assets/images/partners/kushki.png';
import stripeLogo from '@assets/images/partners/stripe.png';
import arcusLogo from '@assets/images/partners/arcus.png';
import fintocLogo from '@assets/images/partners/fintoc.png';
import monatoLogo from '@assets/images/partners/monato.png';

import useStyles from './styles';

export interface IFormPartnerLogoProps {
  partner: string;
}

const FormPartnerLogo: FC<IFormPartnerLogoProps> = ({ partner }) => {
  const css = useStyles();

  const getPartnerLogo = (partner: string) => {
    switch (partner) {
      case Partner.OPENPAY:
        return <img className={css.openpayLogo} src={openpayLogo} />;
      case Partner.BLUMON:
        return <img className={css.blumonLogo} src={blumonLogo} />;
      case Partner.REDPAY:
        return <img className={css.redpayLogo} src={redpayLogo} />;
      case Partner.STRIPE:
        return <img className={css.stripeLogo} src={stripeLogo} />;
      case Partner.ARCUS:
        return <img className={css.arcusLogo} src={arcusLogo} />;
      case Partner.FINTOC:
        return <img className={css.fintocLogo} src={fintocLogo} />;
      case Partner.MONATO:
        return <img className={css.monatoLogo} src={monatoLogo} />;
      case Partner.KUSHKI:
        return <img className={css.kushkiLogo} src={kushkiLogo} />;
      case Partner.STP:
        return <img className={css.stpLogo} src={stpLogo} />;
      case Partner.BELVO:
        return <img className={css.belvoLogo} src={belvoLogo} />;
      default:
        return null;
    }
  };

  return (
    <div className={css.logoPartnerContainer}>
      <Grid container>
        <Grid xs={6} alignContent="center" className={css.textContainer}>
          Funciona con
        </Grid>
        <Grid xs={6} alignContent="center" className={css.logoContainer}>
          {getPartnerLogo(partner)}
        </Grid>
      </Grid>
    </div>
  );
};

export default FormPartnerLogo;
